import React from "react";
import './cookies.css';

const Cookies = ()=>{
    return(
        <>
        <div className="cookies">
            <div className="cookies-container">
                <p className="header">Cookies </p>
                <p className="cookies-content">
                We use cookies on this site for monitoring user behaviour and tracking web traffic. The cookies take up little space on your device andfacilitates and personalises your browsing experience. They may be set by us or by third party providers whose services we add to our pages.

The cookies may be set through our website by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device.
</p>
            </div>
        </div>
        
        </>
    )
}

export default Cookies;